.field {
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	min-width: 0;
}
.col12 {
	grid-column: span 12;
}
.col6 {
	grid-column: span 6;
}

.label {
	font-weight: 600;
	font-size: 0.875rem;
	color: #374151;
	margin-bottom: 0;
}
.req {
	color: #ef4444;
	margin-left: 2px;
}

.inputWrapper {
	width: 100%;
}

.inputGroupedWrapper {
	position: relative;
	flex: 1;
	min-width: 0;
}

.inputGroup {
	display: flex;
	width: 100%;
	align-items: stretch;
}

.inputGroup:focus-within .addon,
.inputGroup:focus-within .inputGrouped {
	border-color: #c7d2fe;
}

.inputGroup:focus-within .inputGrouped {
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.inputGroupError .addon,
.inputGroupError .inputGrouped {
	border-color: #ef4444;
}

.inputGroupError:focus-within .inputGrouped {
	box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}

.addon {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.5rem 0.65rem;
	font-size: 0.85rem;
	font-weight: 600;
	color: #64748b;
	background: #f8fafc;
	border: 1px solid #e5e7eb;
	white-space: nowrap;
	transition: border-color 0.15s ease;
}

.inputGroupBefore .addon:first-of-type {
	border-radius: 0.5rem 0 0 0.5rem;
	border-right: none;
}

.inputGroupAfter:not(.inputGroupBefore) .addon:last-of-type {
	border-radius: 0 0.5rem 0.5rem 0;
	border-left: none;
}

.inputGroupBefore.inputGroupAfter .addon:last-of-type {
	border-radius: 0 0.5rem 0.5rem 0;
	border-left: none;
}

.addonUnitSuffix {
	min-width: 4.85rem;
	justify-content: flex-start;
}

.inputGroupBefore:not(.inputGroupAfter) .inputGrouped {
	border-radius: 0 0.5rem 0.5rem 0;
	border-left: none;
}

.inputGroupAfter:not(.inputGroupBefore) .inputGrouped {
	border-radius: 0.5rem 0 0 0.5rem;
	border-right: none;
}

.inputGroupBefore.inputGroupAfter .inputGrouped {
	border-radius: 0;
	border-left: none;
	border-right: none;
}

.inputGrouped {
	border-radius: 0;
}

.inputGrouped:focus {
	z-index: 1;
}

.inputGroupSm .addon {
	padding: 0.4rem 0.55rem;
	font-size: 0.8rem;
}

.inputGroupLg .addon {
	padding: 0.6rem 0.75rem;
	font-size: 0.95rem;
}

.inputGroup:has(.input:disabled) .addon {
	background: #f3f4f6;
	color: #9ca3af;
	border-color: #e5e7eb;
}

.input {
	width: 100%;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	padding: 0.5rem 0.65rem;
	font-size: 0.95rem;
	color: #111827;
	background: #fff;
	outline: none;
	text-align: right;
	transition:
		border-color 0.15s ease,
		box-shadow 0.15s ease;
}
.input:focus {
	border-color: #c7d2fe;
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.input:disabled {
	background: #f3f4f6;
	color: #9ca3af;
	border-color: #e5e7eb;
	cursor: not-allowed;
	opacity: 1;
}
.inputError {
	border-color: #ef4444;
}
.inputError:focus {
	border-color: #ef4444;
	box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
}

.sm {
	padding: 0.4rem 0.6rem;
	font-size: 0.9rem;
}
.md {
	padding: 0.5rem 0.65rem;
	font-size: 0.95rem;
}
.lg {
	padding: 0.6rem 0.75rem;
	font-size: 1rem;
}

.helper {
	font-size: 0.8rem;
	color: #6b7280;
}
.error {
	font-size: 0.8rem;
	color: #b91c1c;
	margin-top: -5px;
}

@media (max-width: 640px) {
	.col6 {
		grid-column: span 12;
	}
}
